import {useEffect, useState} from 'react'
import {Link, useSearchParams} from 'react-router-dom'
import {verifyEmail} from '../core/_requests'

export function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const performVerification = async () => {
      if (!token) {
        setStatus('error')
        setMessage('Invalid verification link.')
        return
      }

      try {
        await verifyEmail(token)
        setStatus('success')
        setMessage('Your email has been successfully verified!')
      } catch (error: any) {
        console.error(error)
        setStatus('error')
        setMessage(error.response?.data?.message || 'Verification failed.')
      }
    }

    performVerification()
  }, [token])

  return (
    <div className='w-100'>
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Email Verification</h1>
      </div>

      {status === 'loading' && (
        <div className='text-center'>
          <span className='spinner-border spinner-border-lg align-middle text-primary'></span>
          <div className='mt-5 text-gray-500 fw-semibold fs-6'>
            Verifying your email, please wait...
          </div>
        </div>
      )}

      {status === 'success' && (
        <>
          <div className='alert alert-success d-flex flex-column align-items-center p-5 mb-10'>
            <h4 className='mb-1 text-success'>Success</h4>
            <span>{message}</span>
          </div>
          <Link to='/auth/login' className='btn btn-primary w-100'>
            Go to Login
          </Link>
        </>
      )}

      {status === 'error' && (
        <div className='text-center'>
          <div className='alert alert-danger d-flex align-items-center p-5 mb-10'>
            <i className='ki-duotone ki-shield-cross fs-2hx text-danger me-4'></i>
            <div className='d-flex flex-column'>
              <h4 className='mb-1 text-danger'>Error</h4>
              <span>{message}</span>
            </div>
          </div>
          <Link to='/auth/login' className='btn btn-light-primary w-100 mb-5'>
            Back to Login
          </Link>
          <p className='text-gray-500 fw-semibold fs-6'>
            If the link expired, try logging in to resend the verification email.
          </p>
        </div>
      )}
    </div>
  )
}
